// app/javascript/controllers/webauthn_session_form_controller.js
import { Controller } from "@hotwired/stimulus";
import { get, parseRequestOptionsFromJSON } from "@github/webauthn-json/browser-ponyfill";
import { conditionalMediationAvailable } from "../conditional_mediation_available";

export default class extends Controller {
  static targets = ["credential", "status", "cta"];

  connect() {
    this.element.addEventListener("submit", this.submit.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("submit", this.submit.bind(this));
  }

  async submit(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const available = await conditionalMediationAvailable();
    if (available) {
       await this.getChallengeAndSubmitCredential();  // Call with `this`
    } else {
      // Handle when conditional mediation is not available if needed
    }
  }

  async getChallengeAndSubmitCredential() {
    const csrfToken = document.getElementsByName("csrf-token")[0].content;
    let newChallengeURL = new URL(this.data.get("challenge-url"));

    try {
      const challengeFetch = await fetch(newChallengeURL, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": csrfToken,
        },
      });

      const challengeJSON = await challengeFetch.json();
      const credentialAuthenticationOptions = parseRequestOptionsFromJSON({
        publicKey: challengeJSON,
      });
      this.showStatus();
      // Update status to indicate we're waiting for a response from the browser
      this.updateStatus("Waiting for input from browser interaction...", "loading");
      this.hideCTA();

      // Attempt to get credential authentication response
      const credentialAuthenticationResponse = await get(credentialAuthenticationOptions);

      // Update credential and submit form
      this.credentialTarget.value = JSON.stringify(credentialAuthenticationResponse);
      this.element.submit();
    } catch (error) {
      this.updateStatus("Authentication failed, please try again", "error");
      this.showCTA();
    }
  }

  updateStatus(message, icon) {
    if (this.hasStatusTarget) {
      var content = "";
      var color_icon = "";
      var color_message = "";

      if(icon === "error") {
        color_icon = "text-red-600"
        color_message = "text-red-600"
        content += `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" class="${color_icon}"><g clip-path="url(#a)"><path fill="currentColor" fill-rule="evenodd" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm0-3.8a.85.85 0 1 0 0-1.7.85.85 0 0 0 0 1.7Zm.75-7.7a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0v-4Z" clip-rule="evenodd"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></svg>`;
      } else {
        color_icon = "text-primary"
        color_message = "text-gray-500"
        content += `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" class="${color_icon} animate-spin"><g stroke="currentColor" stroke-width="3" clip-path="url(#a)"><path d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z" opacity=".25"/><path d="M2 8a6 6 0 0 1 6-6" opacity=".75"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></svg>`;
      }
      content += `<div class="${color_message}">${message}</div>`;

      var html = `<div class="flex items-center gap-2">${content}</div>`;

      this.statusTarget.innerHTML = html;
    }
  }

  hideCTA() {
    if (this.hasCtaTarget) {
      this.ctaTarget.classList.add("hidden");
    }
  }

  showCTA() {
    if (this.hasCtaTarget) {
      this.ctaTarget.classList.remove("hidden");
    }
  }

  hideStatus() {
    if (this.hasStatusTarget) {
      this.statusTarget.classList.add("hidden");
    }
  }

  showStatus() {
    if (this.hasStatusTarget) {
      this.statusTarget.classList.remove("hidden");
    }
  }
}